export function ResetApplicantIsOwner()
{
    //Zmiana p�l z read-only na normalne
    document.querySelector('input[name="ownerPerson[name]"]').classList.remove("Mui-disabled");
    document.querySelector('input[name="ownerPerson[surname]"]').classList.remove("Mui-disabled");
    document.querySelector('input[name="ownerPerson[email]"]').classList.remove("Mui-disabled");
    document.querySelector('input[name="ownerPerson[phone]"]').classList.remove("Mui-disabled");
    document.querySelector('input[name="ownerPerson[name]"]').parentElement.classList.remove("Mui-disabled");
    document.querySelector('input[name="ownerPerson[surname]"]').parentElement.classList.remove("Mui-disabled");
    document.querySelector('input[name="ownerPerson[email]"]').parentElement.classList.remove("Mui-disabled");
    document.querySelector('input[name="ownerPerson[phone]"]').parentElement.classList.remove("Mui-disabled");
}